import React, { useEffect } from "react";
import TableauEmbedProgrammaticFiltering from "./TableauEmbedProgrammaticFiltering";

export default function TableauRouter({ content, config, setError }) {
  useEffect(() => {
    if (!content?.config?.provider) {
      setError("Provider type does not exist.");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content?.config?.provider]);

  return <>{config?.type === "IFRAME_EMBED" && <TableauEmbedProgrammaticFiltering content={content} />}</>;
}
